<klt-section title="Sector Investability">
  <div class="graph-box">
    <klt-graph
      height="380px"
      [loading]="titles.length == 0"
      [options]="options"
      [titles]="titles"
      [titleSummary]="investabilityDescription"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
